import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { useFrequentTripsQuery } from '@/services/api/catalogApi';
import TripShortcutCard from './TripShortcutCard';

/**
 * Shortcuts to the trips customers book most, below the trip browser — one
 * click loads that route's pickup and destination straight into the booking
 * flow. Renders nothing until there is real booking history to rank on.
 */
export function FrequentTripsSection() {
  const { t } = useTranslation();
  const { data: trips, isLoading, isError } = useFrequentTripsQuery();

  if (isLoading || isError || !trips || trips.length === 0) {
    return null;
  }

  return (
    <Box component="section" sx={{ py: { xs: 6, md: 8 } }}>
      <Container maxWidth="lg">
        <Stack spacing={4}>
          <Stack spacing={0.5}>
            <Typography variant="h2" component="h2">
              {t('home.frequentTrips.title')}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {t('home.frequentTrips.subtitle')}
            </Typography>
          </Stack>

          <Box
            sx={{
              display: 'grid',
              gap: 3,
              // Admin-configurable (3, 4 or 6 trips): auto-fit rather than a
              // fixed column count, so however many come back from the
              // backend lay out reasonably across every breakpoint instead of
              // leaving empty cells or overflowing a column count sized for
              // the old fixed six.
              gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
            }}
          >
            {trips.map((trip) => (
              <TripShortcutCard key={trip.slug} trip={trip} />
            ))}
          </Box>
        </Stack>
      </Container>
    </Box>
  );
}

export default FrequentTripsSection;
